import { useState } from "react";
import { IPaginationPayload } from "../../../interfaces/shared/IPaginationPayload";
import { useGetAllRoomsRequestsQuery } from "../../../store/reservations/reservationsApi";
import RoomRequestTable from "./tables/RoomRequestTable";

const RoomRequests = () => {
	const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
	const {data, isLoading} = useGetAllRoomsRequestsQuery(paginationState);

	return (
		<div>
			<div>
				<p className='page-title'>Rooms requests</p>
			</div>
			<RoomRequestTable 
				rows={data?.data?.elements || []}
				paginationData={data?.data.page}
				rowsLoading={isLoading}
				setPaginationState={setPaginationState}
			/>
		</div>
	)
}

export default RoomRequests;